'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function loadNotifications(url) {
    $('.sidebar-notifications__list').append(
      '<div class="sidebar-notifications__loading">Loading...</div>'
    );

    $.get(url).done((data) => {
      $('.sidebar-notifications__list').find('.sidebar-notifications__loading').remove();
      $('.sidebar-notifications__list').append(data.html);
      groupMessageNotifications();

      if (data.next_page === null) {
        $('.sidebar-notifications__list').removeData('next-page');
      } else {
        if (
          $('.sidebar-notification')[0].scrollHeight * $('.sidebar-notification').length <=
          $('.sidebar-notifications__list').outerHeight(true)
        ) {
          loadNotifications(`/notifications?page=${data.next_page}`);
        } else {
          $('.sidebar-notifications__list').data().nextPage = data.next_page;
        }
      }
    });
  }

  $(document).on('click', '.nav-notifications__counter', () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    $('body').css({
      overflow: 'hidden',
      'padding-right': `${scrollbarWidth}px`,
    });
    $('.intercom-namespace').addClass('hide');
    $('.sidebar-notifications').show('slide', { direction: 'right' }, 400);

    loadNotifications('/notifications');

    $('.sidebar-notifications__list').scrollTop(0);
    $('.sidebar-notifications-overlay').fadeIn();
    return false;
  });
  $(document).on(
    'click',
    '.sidebar-notifications__close, .sidebar-notifications-overlay, .sidebar-notification__link, .h-s-button--notification-group',
    () => {
      $('body').css({
        overflow: 'auto',
        'padding-right': 0,
      });
      $('.intercom-namespace').removeClass('hide');
      $('.sidebar-notifications').hide('slide', { direction: 'right' }, 300);
      $('.sidebar-notifications__list').empty();
      $('.sidebar-notifications-overlay').fadeOut();
    }
  );
  $('.sidebar-notifications__list').scroll((e) => {
    const $this = $(e.target);
    const height = Math.floor(e.target.scrollHeight - $this.height()); // Get the height of the div
    const scroll = Math.ceil($this.scrollTop()); // Get the vertical scroll position

    const isScrolledToEnd = scroll >= height;
    if (isScrolledToEnd) {
      const nextPage = $this.data().nextPage;
      if ($('.sidebar-notifications__loading').length || nextPage === undefined) {
        return;
      }

      loadNotifications(`/notifications?page=${nextPage}`);
    }
  });

  function groupMessageNotifications() {
    $('.sidebar-notification--message').each(function () {
      if (!$(this).hasClass('sidebar-notification--message')) {
        return;
      }
      const messageProjectId = $(this).attr('data-project-id');
      const $messageGroup = $(this).nextUntil(
        `:not(.sidebar-notification--message[data-project-id="${messageProjectId}"])`,
        `.sidebar-notification--message[data-project-id="${messageProjectId}"]`
      );
      const totalMessages = $messageGroup.length + 1;

      if (totalMessages > 2) {
        const $secondMessage = $messageGroup.eq(0);
        const additionalMessages = totalMessages - 1;
        const fadeElement = '<div class="sidebar-notification__fade"></div>';
        const moreMessagesLink = $(this)
          .find('.sidebar-notification__link--open-discussion-panel')
          .attr('href');
        const moreMessagesText = `<div class="notification-group-divider">
          <a href="${moreMessagesLink}" class="h-s-button button-md h-s-button--open-discussion-panel h-s-button--notification-group">
            + ${additionalMessages} additional ${additionalMessages === 1 ? 'message' : 'messages'}
          </a>
        </div>`;

        $secondMessage
          .addClass('sidebar-notification--with-fade')
          .append(fadeElement)
          .after(moreMessagesText);
        $messageGroup.slice(1).remove();
      }
    });
  }
});
